export class DocumentoDetalleEntrada {

    public id: number;
    public codigoDocumento: string;
    public codigoConsorcio: string;
    public codigoArticulo: string;
    public idLinea: number;
    public nombreArticulo: string;
    public cantidad: number;
    public lote: string;
    public dua: string;
    public contenedor: string;
    public referencia1: string;
    public referencia2: string;
    public fecha: string;
    public movInv: string;
    public factura: string;
    public listaEmpaque: string;
    public valorCIF: number;
    public impuestos: number;
    public bultos: number;
    public kilos: number;
    public comentarios: string;
    public tipoIngreso: string;

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/documento-detalle-entrada.ts